<template>
  <VerifyIdentityMfa
    :mfaPreference="mfaPreference"
    :displayCheck="displayCheck"
    :displayCodeResend="displayCodeResend"
    :displayCodeSent="displayCodeSent"
    :displayErrorPage="displayErrorPage"
    :displayExplanation="displayExplanation"
    :displayMfaCodeError="displayMfaCodeError"
    :helperText="
      coalescedSupportText('common.contact_health_plan_csr.contact_info_change')
    "
    @requestMfaCode="onRequestMfaCode"
    @verifyMfaCode="onSubmitMfaCode"
    @cancel="handleReturn"
  />
</template>

<script>
import { VerifyIdentityMfa } from '../../../common/mfa'
import supportMixin from '../../../mixins/support'
import {
  TOO_MANY_SEND_ATTEMPTS,
  TOO_MANY_CHECK_ATTEMPTS,
} from '@platform-shared/verify-constants.js'
import { MFA_TYPES } from '@platform-shared/constants'
import { mapGetters, mapActions } from 'vuex'
import { formatPhoneNumber } from '@platform-shared/utils/formatters'
import verifyIdentityMixin from '@platform-shared/mixins/verifyIdentityMixin'

export default {
  components: {
    VerifyIdentityMfa,
  },
  mixins: [supportMixin, verifyIdentityMixin],
  props: {
    isSSORegister: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    displaySuccessPage: false,
    displayErrorPage: false,
    displayMfaCodeError: false,
    displayCodeResend: false,
  }),
  computed: {
    ...mapGetters('registration', ['isFetching', 'mfaPreference']),
    displayCheck() {
      return this.mfaPreference === MFA_TYPES.EMAIL
        ? this.$t('mfa.check_email')
        : this.$t('mfa.check_phone')
    },
    displayCodeSent() {
      const validType = Object.values(MFA_TYPES).find(
        (x) => x === this.mfaPreference
      )
      let result
      switch (validType) {
        case MFA_TYPES.EMAIL:
          result = this.coalesceContactInfo.email
          break
        case MFA_TYPES.SMS:
          result = formatPhoneNumber(this.coalesceContactInfo.primarySmsPhone)
          break
        case MFA_TYPES.VOICE:
          result = formatPhoneNumber(this.coalesceContactInfo.primaryPhone)
          break
        default:
          result = null
      }
      return result ? this.$t('mfa.code_sent', [result]) : ''
    },
    displayExplanation() {
      return this.mfaPreference === MFA_TYPES.EMAIL
        ? this.$t('mfa.explanation_email')
        : this.$t('mfa.explanation_phone')
    },
  },
  methods: {
    ...mapActions('registration', [
      'submitRegistrationMfa',
      'submitSsoRegistrationMfa',
    ]),
    ...mapActions('member', ['requestMfaCode']),
    ...mapActions(['logout']),
    handleReturn() {
      this.logout()
    },
    onRequestMfaCode() {
      this.requestMfaCode()
        .then(() => {
          this.displayCodeResend = true
          setTimeout(() => {
            this.displayCodeResend = false
          }, 5000)
        })
        .catch((e) => {
          if (e.message === TOO_MANY_SEND_ATTEMPTS) {
            this.displayErrorPage = true
          }
        })
    },
    onSubmitMfaCode(totp) {
      this.mfaCodeError = false

      if (this.isSSORegister) {
        this.submitSsoRegistrationMfa(totp)
          .then(() => {
            this.displaySuccessPage = true
            setTimeout(() => {
              this.$emit('next')
            }, 3000)
          })
          .catch((e) => {
            if (e.message === TOO_MANY_CHECK_ATTEMPTS) {
              this.displayErrorPage = true
            } else {
              this.displayMfaCodeError = true
            }
          })
      } else {
        this.submitRegistrationMfa(totp)
          .then(() => {
            this.displaySuccessPage = true
            setTimeout(() => {
              this.$emit('next')
            }, 3000)
          })
          .catch((e) => {
            if (e.message === TOO_MANY_CHECK_ATTEMPTS) {
              this.displayErrorPage = true
            } else {
              this.displayMfaCodeError = true
            }
          })
      }
    },
  },
}
</script>
